import { defineStore } from 'pinia'
import { v4 } from 'uuid'

/**
 * 系統狀態
 */
export const useGlobalStateStore = defineStore('global-state', () => {
  /** App.vue 使用的 key */
  const fullPageKey = ref<string>(v4())
  /** main-layout.vue 使用的 key */
  const routerViewKey = ref<string>(v4())

  /** 重新載入完整網站 */
  function reloadFullPage() {
    fullPageKey.value = v4()
  }

  /** 重新載入 view 組件（不含 Layout） */
  function reloadRouterView() {
    routerViewKey.value = v4()
  }

  return {
    /** App.vue 使用的 key */
    fullPageKey,
    /** 重新載入完整網站 */
    reloadFullPage,
    /** main-layout.vue 使用的 key */
    routerViewKey,
    /** 重新載入 view 組件（不含 Layout） */
    reloadRouterView
  }
})
